module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/53abdcf3925c1f3448c8385c48104362.png";